/**
 * Non-react access to query parameters. This is outside of the history
 * object of the app, and would not, for example cause re-render on changes
 */
export const getQueryParams = () => {
  const locationParams = new URLSearchParams(window.location.search);

  return locationParams;
};

export const noop = () => {};

export const noopAsync = async () => {};

export type DeepPartial<T> = T extends object
  ? // Same reasoning as the below
    T extends Map<any, any>
    ? T
    : // Avoid going deep into arbitrary fields - Requires key value map shenanigans to get types working again if you're merging two objects together
    Record<string, any> extends T
    ? T
    : // Avoids creating undefine-able array items - Also generally you don't want deep partial to go all the way to individual items
    T extends Array<any>
    ? T
    : T extends (...args: any[]) => any
    ? T
    : // Accounts for nominally typed strings
    T extends string
    ? T
    : { [P in keyof T]?: DeepPartial<T[P]> }
  : T;
